import { useNavigate } from '@tanstack/react-router'
import { Coffee, Plus } from 'lucide-react'
import { useTelegram } from '@/shared/lib/telegram'
import { Button } from '@/shared/ui'

/**
 * Пустое состояние дневника
 */
export function EmptyState() {
  const navigate = useNavigate()
  const { hapticFeedback } = useTelegram()

  const handleAdd = () => {
    hapticFeedback.impactOccurred('light')
    navigate({ to: '/tea-diary/add' })
  }

  return (
    <div className="flex flex-col items-center justify-center px-6 py-12 text-center animate-in fade-in duration-300">
      <div className="w-16 h-16 rounded-full bg-gray-100 dark:bg-dark-elevated flex items-center justify-center mb-4">
        <Coffee className="w-8 h-8 text-gray-400" />
      </div>
      
      <h2 className="text-lg font-semibold text-ink dark:text-white mb-1">
        Дневник пуст
      </h2>
      <p className="text-sm text-gray-500 dark:text-gray-400 mb-6 max-w-xs">
        Начните записывать свои чайные впечатления
      </p>
      
      <Button
        variant="primary"
        leftIcon={<Plus className="w-4 h-4" />}
        onClick={handleAdd}
      >
        Первая запись
      </Button>
    </div>
  )
}
